// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"354":"fa56b41a","688":"bc9a058e","905":"fa56b41a"}[chunkId] + ".chunk.css";
};